import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { sortByMonthChartData } from '../../../utils/functionUtils';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SubscriptionReport = ({
    chartReportCountSuccess,
    reportName,
    getBgColor
}) => {

    const options = {
        plugins: {
          title: {
            display: true,
            text: reportName,
            align: 'start',
            font: {
              size: 20,
            },
            padding: {
              // bottom: 40
            }
          },
          legend: {
            align: 'end',
            position: 'top',
            labels: {
              font: {
                weight: 500,
                color: 'black',
                size: 14,
              }
            }
          },
          datalabels: {
            formatter: function(value, context) {
              // return value > 0 ? value+'%' : null;
            },
            align: "top",
            anchor: "end",
            labels: {
                usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        size: 16,
                    }
            },
          }
        },
        responsive: true,
        scales: {
          x: {
            stacked: true,
            grid: {
              display:false
            }
          },
          y: {
            stacked: true,
            grid: {
              display:false
            }
          },
        },
        // barThickness: 15
      };
      
      const sortEnrollmentReportCount = sortByMonthChartData(chartReportCountSuccess['EnrollmentReportCount']);

      const enrollmentReportCount = {
        Months: sortEnrollmentReportCount?.map(v => v?.Month),
        ['Total Subscriptions']: sortEnrollmentReportCount?.map(v => v?.['Total Subscriptions']),
        ['Accepted Subscriptions']: sortEnrollmentReportCount?.map(v => v?.['Accepted Subscriptions']),
        ['Rejected Subscriptions']: sortEnrollmentReportCount?.map(v => v?.['Rejected Subscriptions'])
      }
      
      let labels = enrollmentReportCount?.Months

      let subscriptionLabel = ['Accepted Subscriptions', 'Rejected Subscriptions']

       let _reportData =[]
      for(let i=0; i < (subscriptionLabel.length); i++){
        _reportData.push({
            label: subscriptionLabel[i],
            data: enrollmentReportCount[subscriptionLabel[i]],
            backgroundColor: getBgColor[i],
            stack: i
        })
      }

       const reportData = {
        labels,
        datasets: _reportData,
      };

    return(
        <div>
            <Bar options={options} data={reportData} />
        </div>
    )
}

export default SubscriptionReport